import * as defaultImport from "@splunk/datasources";
export * from "@splunk/datasources";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
